module.exports = __webpack_public_path__ + "assets/img/d4cc-ye.svg";